import { checkInventoryStatus } from './checkInventoryStatus';
import { checkShippingValidity } from './checkShippingValidity';

export const shouldShowCheckoutUpsell = (
  upsellData: {
    cartSKU: string;
    upsellProductId: string;
    upsellSKUs: string[];
    shippable: boolean;
  }[],
  cartSkuArray: string[]
) => {
  let upsellProductId: string | undefined;
  let upsellSKUs: string[] | undefined;
  let selectedUpsellObj:
    | {
        cartSKU: string;
        upsellProductId: string;
        upsellSKUs: string[];
        shippable: boolean;
      }
    | undefined;

  for (const cartSKU of cartSkuArray) {
    const correctUpsellObj = upsellData.find(
      (upsellObj) => (upsellObj.cartSKU = cartSKU)
    );

    if (correctUpsellObj) {
      const { upsellInventoryStatus } = checkInventoryStatus(
        correctUpsellObj.upsellProductId
      );

      const requiresShipping = correctUpsellObj.shippable;
      const { shippingValid } = checkShippingValidity(requiresShipping);

      if (upsellInventoryStatus === 'AVAILABLE' && shippingValid) {
        upsellProductId = correctUpsellObj.upsellProductId;
        upsellSKUs = correctUpsellObj.upsellSKUs;
        selectedUpsellObj = correctUpsellObj;
      }

      break;
    }
  }

  const currentCartSKUs: string[] = JSON.parse(
    localStorage.getItem('fp-skus') || '[]'
  );

  const isAlreadyInCart = selectedUpsellObj?.upsellSKUs.some((SKU) =>
    currentCartSKUs.includes(SKU)
  );

  let showUpsell = false;
  if (upsellProductId && !isAlreadyInCart) {
    showUpsell = true;
  }

  return { showUpsell, upsellProductId, upsellSKUs };
};
